// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_SaveInput — body for POST /subscriptions/admin-terms/save.
 *
 * Creates a version when `id` is null, renames one when it is set. It carries
 * NO body: the wording belongs to a language variant, saved through
 * variant-save. A version is always born unpublished — publishing is the
 * separate `activate` call, so saving can never silently change the text a
 * franchise is asked to sign.
 *
 * SHAPE ONLY HERE. Whether the plan exists and is current is a database
 * question and the controller's refusal ('plano_nao_encontrado'); a contract
 * does no I/O.
 */
import { registerContract } from './validate'

export interface SubscriptionTerms_SaveInput {
plan_id: number
titulo: string
versao: string
id?: number
}

registerContract('SubscriptionTerms_SaveInput', {
  plan_id: { type: 'number',  required: true },
  titulo:  { type: 'string',  required: true },
  versao:  { type: 'string',  required: true },
  id:      { type: 'number',  required: false },
})
